<template>
  <div id="container">
    <user-image :puntaje="puntaje" :img="imageUser"></user-image>
    <span class="numeroPregunta">Pregunta: {{ pregunta }}</span>
    <!-- <button @click="saltarIzquierda()">saltarIzquierda</button>
    <button @click="saltar()">saltar</button>
    <button @click="saltarDerecha()">saltarDerecha</button> -->
    <div class="cuestionario">
      <div class="pregunta">
        <h3>¿{{ textoPregunta }}?</h3>
      </div>
      <div class="respuestas">
        <h3 class="respuesta1">{{ textoRespuesta1 }}</h3>
        <h3 class="respuesta2">{{ textoRespuesta2 }}</h3>
        <h3 class="respuesta3">{{ textoRespuesta3 }}</h3>
      </div>
    </div>
    <div class="keyboard">
      <!-- Top Row -->
      <div class="top-row">
        <!-- Key -->
        <div data-key="87" class="key">
          <span class="arriba">avanzar </span>
          <!-- Character -->
          <p><font-awesome-icon icon="fa-solid fa-up-long" /></p>
        </div>
      </div>
      <!-- Bottom Row -->
      <div class="bottom-row">
        <!-- Key -->
        <div data-key="65" class="key">
          <!-- Character -->
          <p><font-awesome-icon icon="fa-solid fa-left-long" /></p>
        </div>
        <!-- Key -->
        <div data-key="83" class="key">
          <span class="derecha">mirar hacia la derecha</span>
          <!-- Character -->
          <p><font-awesome-icon icon="fa-solid fa-down-long" /></p>
        </div>
        <!-- Key -->
        <div data-key="68" class="key">
          <span class="izquierda">mirar hacia la izquierda</span>
          <!-- Character -->
          <p><font-awesome-icon icon="fa-solid fa-right-long" /></p>
        </div>
      </div>
    </div>
    <div v-if="felicidades" class="felicidades">
      <img src="@/assets/img/icons3D/exam.png" alt="column" />
      <h2>¡FELICITACIONES!</h2>
      <p>
        Acabas de culminar el modulo de <b>Transformadas 3D</b>, sigue adelante,
        el proximo modulo a cursar es muy interesante.
      </p>
      <router-link class="botonLogro" to="/menu">Continuar</router-link>
    </div>

    <!-- <barra-herramientas /> -->
    <menu-vertical
      class="menu"
      :explicacion="pathModulo.explicacion"
      :demostracion="pathModulo.demostracion"
      :actividad="pathModulo.actividad"
      :cuestionario="pathModulo.cuestionario"
    ></menu-vertical>
  </div>
</template>
<script>
import MenuVertical from "@/components/MenuVertical.vue";
import UserImage from "@/components/UserImage.vue";
import * as Three from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { TWEEN } from "three/examples/jsm/libs/tween.module.min";
// import BarraHerramientas from "@/components/BarraHerramientas.vue";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
export default {
  components: { MenuVertical, UserImage },
  name: "CuestionarioSistemaCoordenadas",
  data() {
    return {
      puntaje: 0,
      textoPregunta: "",
      derFrente: false,
      mixer: null,
      camera: null,
      scene: null,
      renderer: null,
      gridHelper: null,
      controls: null,
      model2: null,
      loader: null,
      clock: null,
      gltf: null,
      cont: 2,
      base1: null,
      base2: null,
      base3: null,
      base4: null,
      pregunta: 1,
      cuestionarios: [],
      textoRespuesta1: "",
      textoRespuesta2: "",
      textoRespuesta3: "",
      felicidades: false,
      keyControls: true,
      decodeToken: null,
      imageUser:
        "https://cdn.pixabay.com/photo/2018/04/18/18/56/user-3331256__340.png",
      logros: [],
      pathModulo: {
        explicacion: "/sistema-de-coordenadas",
        demostracion: "/demostracion-sistema-de-coordenadas",
        actividad: "/actividad-sistema-de-coordenadas",
        cuestionario: "/cuestionario-sistema-de-coordenadas",
      },
    };
  },
  methods: {
    init: function () {
      let container = document.getElementById("container");
      this.camera = new Three.PerspectiveCamera(
        45,
        container.clientWidth / container.clientHeight,
        0.01,
        2000
      );
      this.camera.position.z = -30;
      this.camera.position.y = 10;
      this.scene = new Three.Scene();
      // this.scene.rotation.x = Math.PI / 2;
      const size = 40;
      const divisions = 40;
      this.gridHelper = new Three.GridHelper(size, divisions);
      // this.scene.add(this.gridHelper);

      this.renderer = new Three.WebGLRenderer({ antialias: true });
      this.renderer.setSize(container.clientWidth, container.clientHeight);
      container.appendChild(this.renderer.domElement);

      const hemiLight = new Three.HemisphereLight(0xffffff, 0x444444);
      hemiLight.position.set(0, 20, 0);
      this.scene.add(hemiLight);

      const dirLight = new Three.DirectionalLight(0xffffff);
      dirLight.position.set(0, 20, 10);
      this.scene.add(dirLight);

      this.controls = new OrbitControls(this.camera, this.renderer.domElement);

      this.controls.update();

      this.loader = new GLTFLoader();

      this.loader.load("models/RobotExpressive.glb", (gltf) => {
        // console.log(gltf);
        this.gltf = gltf;
        this.model2 = gltf.scene;
        this.model2.position.z = -20;
        this.model2.position.y = 3.1;
        // console.log(this.model2);
        this.scene.add(this.model2);
        this.mixer = new Three.AnimationMixer(this.model2);
        this.mixer.clipAction(gltf.animations[2]).play();
        // this.saltar();
        // this.camera.position.z = this.model2.position.z - 6;
        this.controls.enablePan = false;
        this.controls.enableRotate = false;
        this.controls.enableZoom = false;

        this.controls.target.copy(this.model2.position);
        // this.camera.position.x = 10;
        this.controls.update();
        // console.log("esta es", this.camera.rotation);
      }),
        (xhr) => {
          console.log((xhr.loaded / xhr.total) * 100 + "% loaded");
        },
        (error) => {
          console.error(error);
        };
      this.moverseTeclas();
      this.clock = new Three.Clock();
      this.base1 = this.baseRobot(0, -20);
      this.base2 = this.baseRobot(0, -14);
      this.base3 = this.baseRobot(5, -17);
      this.base4 = this.baseRobot(-5, -17);
      this.scene.add(this.base1);
      this.scene.add(this.base2);
      this.scene.add(this.base3);
      this.scene.add(this.base4);
    },
    frente() {
      document.querySelector(".respuesta1").style.display = "none";
      document.querySelector(".respuesta2").style.display = "block";
      document.querySelector(".respuesta3").style.display = "none";

      this.controls.target.copy(this.model2.position);
      this.controls.update();
      let anguloZ = 0;
      if (this.derFrente) {
        anguloZ = -3.141592653589793;
      } else {
        anguloZ = 3.141592653589793;
      }
      this.derFrente = false;
      new TWEEN.Tween(this.camera.rotation)
        .to(
          {
            x: -2.537609675336795,
            y: 1.0079824289654461e-16,
            z: anguloZ,
          },
          500
        )
        .easing(TWEEN.Easing.Linear.None)
        .start();
      new TWEEN.Tween(this.camera.position)
        .to(
          {
            x: 0,
          },
          500
        )
        .onComplete(() => {
          this.controls.update();
        })
        .easing(TWEEN.Easing.Linear.None)
        .start();
    },
    izq() {
      document.querySelector(".respuesta1").style.display = "none";
      document.querySelector(".respuesta2").style.display = "none";
      document.querySelector(".respuesta3").style.display = "block";
      this.controls.target.copy(this.model2.position);
      this.controls.update();
      new TWEEN.Tween(this.camera.rotation)
        .to(
          {
            x: -2.6536337259547715,
            y: 0.7948980669428198,
            z: 2.7794430965255206,
          },
          500
        )
        .easing(TWEEN.Easing.Linear.None)
        .start();
      new TWEEN.Tween(this.camera.position)
        .to(
          {
            x: 10,
          },
          500
        )
        .easing(TWEEN.Easing.Linear.None)
        .onComplete(() => {
          this.controls.target.copy(
            new Three.Vector3(
              this.model2.position.x - 5,
              this.model2.position.y,
              this.model2.position.z + 3
            )
          );

          this.controls.update();
          // console.log(this.camera.rotation);
        })
        .start();
    },
    der() {
      document.querySelector(".respuesta1").style.display = "block";
      document.querySelector(".respuesta2").style.display = "none";
      document.querySelector(".respuesta3").style.display = "none";
      this.controls.target.copy(this.model2.position);
      this.controls.update();
      this.derFrente = true;
      new TWEEN.Tween(this.camera.rotation)
        .to(
          {
            x: -2.537609675336795,
            y: -0.688656604226934,
            z: 3.5583470690224374,
          },
          500
        )
        .easing(TWEEN.Easing.Linear.None)
        .start();

      new TWEEN.Tween(this.camera.position)
        .to(
          {
            x: -10,
          },
          500
        )
        .easing(TWEEN.Easing.Linear.None)
        .onComplete(() => {
          this.controls.update();
          // console.log(this.camera.rotation);
        })
        .start();
    },
    moverseTeclas() {
      const eventKeys = (event) => {
        if (!this.keyControls) {
          document.removeEventListener("keydown", eventKeys, false);
          console.log("desactivarcontroles dentro de la funcion");
        }
        if (this.keyControls) {
          if (event.key == "ArrowRight") {
            if (this.cont < 3) {
              this.cont += 1;
              this.switchMira();
            }
          }
          if (event.key == "ArrowLeft") {
            if (this.cont > 1) {
              this.cont -= 1;
              this.switchMira();
            }
          }
          if (event.key == "ArrowUp") {
            this.switchSalto();
            console.log("buenas");
          }
        }
      };

      document.addEventListener("keydown", eventKeys, false);

      console.log("activarcontroles");
    },
    switchMira() {
      switch (this.cont) {
        case 1:
          this.der();
          break;
        case 2:
          this.frente();
          break;
        case 3:
          this.izq();
          break;

        default:
          break;
      }
    },
    switchSalto() {
      switch (this.cont) {
        case 1:
          this.saltarIzquierda();
          break;
        case 2:
          this.saltar();
          break;
        case 3:
          this.saltarDerecha();
          break;

        default:
          break;
      }
    },
    saltar() {
      let res = 2;
      this.controls.target.copy(this.model2.position);
      this.controls.update();
      this.cont = 2;
      this.mixer.clipAction(this.gltf.animations[3]).play();
      new TWEEN.Tween(this.model2.position)
        .to(
          {
            z: this.model2.position.z + 6,
          },
          609
        )
        .easing(TWEEN.Easing.Linear.None)
        .onComplete(() => {
          this.mixer.clipAction(this.gltf.animations[3]).stop();
        })
        .start();

      new TWEEN.Tween(this.camera.position)
        .to(
          {
            z: this.model2.position.z - 6,
          },
          609
        )
        .easing(TWEEN.Easing.Linear.None)
        .onComplete(() => {
          this.controls.target.copy(this.model2.position);
          this.controls.update();
          // console.log(this.camera.rotation);
        })
        .start();
      new TWEEN.Tween(this.camera.rotation)
        .to(
          {
            x: -2.6197583737753827,
            y: 1.0616540292000756e-16,
            z: 3.141592653589793,
          },
          609
        )
        .easing(TWEEN.Easing.Linear.None)
        .onComplete(() => {
          this.verificar(this.pregunta, res);
        })
        .start();
    },
    saltarDerecha() {
      let res = 3;
      this.cont = 2;
      this.mixer.clipAction(this.gltf.animations[3]).play();
      new TWEEN.Tween(this.model2.position)
        .to(
          {
            x: this.model2.position.x - 5,
            z: this.model2.position.z + 3,
          },
          609
        )
        .easing(TWEEN.Easing.Linear.None)
        .onComplete(() => {
          this.controls.target.copy(this.model2.position);
          this.controls.update();
          this.mixer.clipAction(this.gltf.animations[3]).stop();
        })
        .start();

      new TWEEN.Tween(this.camera.position)
        .to(
          {
            x: this.model2.position.x - 5,
            z: this.model2.position.z - 10,
          },
          609
        )
        .easing(TWEEN.Easing.Linear.None)
        .onComplete(() => {
          this.controls.target.copy(this.model2.position);
          this.controls.update();
          // console.log(this.camera.rotation);
        })
        .start();
      new TWEEN.Tween(this.camera.rotation)
        .to(
          {
            x: -2.6197583737753827,
            y: 1.0616540292000756e-16,
            z: 3.141592653589793,
          },
          609
        )
        .easing(TWEEN.Easing.Linear.None)
        .onComplete(() => {
          this.verificar(this.pregunta, res);
        })
        .start();
    },
    saltarIzquierda() {
      let res = 1;
      this.cont = 2;
      this.mixer.clipAction(this.gltf.animations[3]).play();
      new TWEEN.Tween(this.model2.position)
        .to(
          {
            x: this.model2.position.x + 5,
            z: this.model2.position.z + 3,
          },
          609
        )
        .easing(TWEEN.Easing.Linear.None)
        .onComplete(() => {
          this.controls.target.copy(this.model2.position);
          this.controls.update();
          this.mixer.clipAction(this.gltf.animations[3]).stop();
        })
        .start();

      new TWEEN.Tween(this.camera.position)
        .to(
          {
            x: this.model2.position.x + 5,
            z: this.model2.position.z - 10,
          },
          609
        )
        .easing(TWEEN.Easing.Linear.None)
        .onComplete(() => {
          this.controls.target.copy(this.model2.position);
          this.controls.update();
          // console.log(this.camera.rotation);
        })
        .start();
      new TWEEN.Tween(this.camera.rotation)
        .to(
          {
            x: -2.653633725954771,
            y: 1.2069546750747522e-16,
            z: -3.141592653589793,
          },
          609
        )
        .easing(TWEEN.Easing.Linear.None)
        .onComplete(() => {
          this.verificar(this.pregunta, res);
        })
        .start();
    },
    verificar(num, res) {
      switch (num) {
        case 1:
          if (res == 1) {
            this.puntaje += 20;
            document.querySelector(".pregunta").style.background = "green";
            document.querySelector(".respuestas").style.background = "green";
            new TWEEN.Tween(this.base2.position)
              .to(
                {
                  y: -30,
                },
                1000
              )
              .easing(TWEEN.Easing.Linear.None)
              .onComplete(() => {
                this.scene.remove(this.base2);
              })
              .start();
            new TWEEN.Tween(this.base1.position)
              .to(
                {
                  y: -30,
                },
                1000
              )
              .easing(TWEEN.Easing.Linear.None)
              .onComplete(() => {
                this.scene.remove(this.base3);
              })
              .start();
            new TWEEN.Tween(this.base4.position)
              .to(
                {
                  y: -30,
                },
                1000
              )
              .easing(TWEEN.Easing.Linear.None)
              .onComplete(() => {
                this.scene.remove(this.base4);
                this.model2.position.z = -20;
                this.model2.position.x = 0;
                this.model2.position.y = 3.1;
                this.camera.position.x = 0;
                this.base1.position.y = -12;
                this.base3.position.y = -30;

                this.pregunta += 1;
                this.resetEscena();
                this.controls.target.copy(this.model2.position);
                this.controls.update();
                document.querySelector(".pregunta").style.background = "blue";
                document.querySelector(".respuestas").style.background =
                  "white";
              })
              .start();

            // this.frente();
          } else {
            document.querySelector(".pregunta").style.background = "red";
            document.querySelector(".respuestas").style.background = "red";
            new TWEEN.Tween(this.base2.position)
              .to(
                {
                  y: -30,
                },
                1000
              )
              .easing(TWEEN.Easing.Linear.None)
              .onComplete(() => {
                this.scene.remove(this.base2);
              })
              .start();
            new TWEEN.Tween(this.base1.position)
              .to(
                {
                  y: -30,
                },
                1000
              )
              .easing(TWEEN.Easing.Linear.None)
              .onComplete(() => {
                this.scene.remove(this.base1);
              })
              .start();
            new TWEEN.Tween(this.base3.position)
              .to(
                {
                  y: -30,
                },
                1000
              )
              .easing(TWEEN.Easing.Linear.None)
              .onComplete(() => {
                this.scene.remove(this.base3);
              })
              .start();
            new TWEEN.Tween(this.model2.position)
              .to(
                {
                  y: -15,
                },
                1000
              )
              .easing(TWEEN.Easing.Linear.None)
              .onComplete(() => {
                // this.scene.remove(this.base2);
              })
              .start();
            new TWEEN.Tween(this.base4.position)
              .to(
                {
                  y: -30,
                },
                1000
              )
              .easing(TWEEN.Easing.Linear.None)
              .onComplete(() => {
                this.scene.remove(this.base4);
                this.scene.add(this.base1);

                this.model2.position.z = -20;
                this.model2.position.x = 0;
                this.model2.position.y = 3.1;

                this.base1.position.x = 0;
                this.base1.position.y = -12;
                this.base1.position.z = -20;

                this.camera.position.x = 0;
                this.camera.position.z = this.model2.position.z - 10;
                this.resetEscena();
                this.controls.target.copy(this.model2.position);

                this.controls.update();
                document.querySelector(".pregunta").style.background = "blue";
                document.querySelector(".respuestas").style.background =
                  "white";
              })
              .start();
          }
          break;
        case 2:
          if (res == 3) {
            this.puntaje += 20;
            document.querySelector(".pregunta").style.background = "green";
            document.querySelector(".respuestas").style.background = "green";
            new TWEEN.Tween(this.base2.position)
              .to(
                {
                  y: -30,
                },
                1000
              )
              .easing(TWEEN.Easing.Linear.None)
              .onComplete(() => {
                this.scene.remove(this.base2);
              })
              .start();
            new TWEEN.Tween(this.base1.position)
              .to(
                {
                  y: -30,
                },
                1000
              )
              .easing(TWEEN.Easing.Linear.None)
              .onComplete(() => {
                this.scene.remove(this.base1);
              })
              .start();
            new TWEEN.Tween(this.base3.position)
              .to(
                {
                  y: -30,
                },
                1000
              )
              .easing(TWEEN.Easing.Linear.None)
              .onComplete(() => {
                this.scene.remove(this.base3);
                this.scene.remove(this.base4);
                this.scene.add(this.base1);
                this.model2.position.z = -20;
                this.model2.position.x = 0;
                this.model2.position.y = 3.1;
                this.camera.position.x = 0;
                this.base1.position.y = -12;
                this.base4.position.y = -30;

                this.pregunta += 1;
                this.resetEscena();
                this.controls.target.copy(this.model2.position);
                this.controls.update();
                document.querySelector(".pregunta").style.background = "blue";
                document.querySelector(".respuestas").style.background =
                  "white";
              })
              .start();

            // this.frente();
          } else {
            document.querySelector(".pregunta").style.background = "red";
            document.querySelector(".respuestas").style.background = "red";
            new TWEEN.Tween(this.base2.position)
              .to(
                {
                  y: -30,
                },
                1000
              )
              .easing(TWEEN.Easing.Linear.None)
              .onComplete(() => {
                this.scene.remove(this.base2);
              })
              .start();
            new TWEEN.Tween(this.base1.position)
              .to(
                {
                  y: -30,
                },
                1000
              )
              .easing(TWEEN.Easing.Linear.None)
              .onComplete(() => {
                this.scene.remove(this.base1);
              })
              .start();
            new TWEEN.Tween(this.base3.position)
              .to(
                {
                  y: -30,
                },
                1000
              )
              .easing(TWEEN.Easing.Linear.None)
              .onComplete(() => {
                this.scene.remove(this.base3);
              })
              .start();
            new TWEEN.Tween(this.model2.position)
              .to(
                {
                  y: -15,
                },
                1000
              )
              .easing(TWEEN.Easing.Linear.None)
              .onComplete(() => {
                // this.scene.remove(this.base2);
              })
              .start();
            new TWEEN.Tween(this.base4.position)
              .to(
                {
                  y: -30,
                },
                1000
              )
              .easing(TWEEN.Easing.Linear.None)
              .onComplete(() => {
                this.scene.remove(this.base4);
                this.scene.add(this.base1);

                this.model2.position.z = -20;
                this.model2.position.x = 0;
                this.model2.position.y = 3.1;

                this.base1.position.x = 0;
                this.base1.position.y = -12;
                this.base1.position.z = -20;

                this.camera.position.x = 0;
                this.camera.position.z = this.model2.position.z - 10;
                this.resetEscena();
                this.controls.target.copy(this.model2.position);
                document.querySelector(".pregunta").style.background = "blue";
                document.querySelector(".respuestas").style.background =
                  "white";
                this.controls.update();
              })
              .start();
          }
          break;
        case 3:
          if (res == 2) {
            this.puntaje += 20;
            document.querySelector(".pregunta").style.background = "green";
            document.querySelector(".respuestas").style.background = "green";
            new TWEEN.Tween(this.base4.position)
              .to(
                {
                  y: -30,
                },
                1000
              )
              .easing(TWEEN.Easing.Linear.None)
              .onComplete(() => {
                this.scene.remove(this.base4);
              })
              .start();
            new TWEEN.Tween(this.base1.position)
              .to(
                {
                  y: -30,
                },
                1000
              )
              .easing(TWEEN.Easing.Linear.None)
              .onComplete(() => {
                this.scene.remove(this.base1);
              })
              .start();
            new TWEEN.Tween(this.base3.position)
              .to(
                {
                  y: -30,
                },
                1000
              )
              .easing(TWEEN.Easing.Linear.None)
              .onComplete(() => {
                this.scene.remove(this.base3);
                this.scene.remove(this.base2);
                this.scene.add(this.base1);
                this.model2.position.z = -20;
                this.model2.position.x = 0;
                this.model2.position.y = 3.1;
                this.camera.position.x = 0;
                this.camera.position.z = -30;
                this.base1.position.y = -12;
                this.base4.position.y = -30;

                // this.pregunta += 1;
                // this.resetEscena();
                this.felicitaciones();
                this.controls.target.copy(this.model2.position);
                this.controls.update();
                document.querySelector(".pregunta").style.background = "blue";
                document.querySelector(".respuestas").style.background =
                  "white";
              })
              .start();

            // this.frente();
          } else {
            document.querySelector(".pregunta").style.background = "red";
            document.querySelector(".respuestas").style.background = "red";
            new TWEEN.Tween(this.base2.position)
              .to(
                {
                  y: -30,
                },
                1000
              )
              .easing(TWEEN.Easing.Linear.None)
              .onComplete(() => {
                this.scene.remove(this.base2);
              })
              .start();
            new TWEEN.Tween(this.base1.position)
              .to(
                {
                  y: -30,
                },
                1000
              )
              .easing(TWEEN.Easing.Linear.None)
              .onComplete(() => {
                this.scene.remove(this.base1);
              })
              .start();
            new TWEEN.Tween(this.base3.position)
              .to(
                {
                  y: -30,
                },
                1000
              )
              .easing(TWEEN.Easing.Linear.None)
              .onComplete(() => {
                this.scene.remove(this.base3);
              })
              .start();
            new TWEEN.Tween(this.model2.position)
              .to(
                {
                  y: -15,
                },
                1000
              )
              .easing(TWEEN.Easing.Linear.None)
              .onComplete(() => {
                // this.scene.remove(this.base2);
              })
              .start();
            new TWEEN.Tween(this.base4.position)
              .to(
                {
                  y: -30,
                },
                1000
              )
              .easing(TWEEN.Easing.Linear.None)
              .onComplete(() => {
                this.scene.remove(this.base4);
                this.scene.add(this.base1);

                this.model2.position.z = -20;
                this.model2.position.x = 0;
                this.model2.position.y = 3.1;

                this.base1.position.x = 0;
                this.base1.position.y = -12;
                this.base1.position.z = -20;

                this.camera.position.x = 0;
                this.camera.position.z = this.model2.position.z - 10;
                this.resetEscena();
                this.controls.target.copy(this.model2.position);

                this.controls.update();
                document.querySelector(".pregunta").style.background = "blue";
                document.querySelector(".respuestas").style.background =
                  "white";
              })
              .start();
          }
          break;
        default:
          break;
      }
    },
    felicitaciones() {
      this.keyControls = false;
      this.moverseTeclas();

      this.mixer.clipAction(this.gltf.animations[2]).stop();
      new TWEEN.Tween(this.base1.rotation)
        .to(
          {
            y: Math.PI,
          },
          1000
        )
        .easing(TWEEN.Easing.Linear.None)
        .onComplete(() => {})
        .start();
      new TWEEN.Tween(this.model2.rotation)
        .to(
          {
            y: Math.PI,
          },
          1000
        )
        .easing(TWEEN.Easing.Linear.None)
        .onComplete(() => {
          this.controls.update();
          // console.log(this.camera.rotation);
          this.mixer.clipAction(this.gltf.animations[0]).play();
        })
        .start();

      // this.model2.rotation.y = Math.PI;
      document.querySelector(".cuestionario").style.display = "none";
      this.felicidades = true;
      //  document.querySelector(".respuesta1").style.display = "none";
      // document.querySelector(".respuesta2").style.display = "none";
      // document.querySelector(".respuesta3").style.display = "none";
      this.logro();
    },
    resetEscena() {
      // this.scene.add(this.base1);
      this.scene.add(this.base2);
      this.scene.add(this.base3);
      this.scene.add(this.base4);
      new TWEEN.Tween(this.base2.position)
        .to(
          {
            y: -12,
          },
          1000
        )
        .easing(TWEEN.Easing.Linear.None)
        .onComplete(() => {
          // this.scene.remove(this.base2);
        })
        .start();
      new TWEEN.Tween(this.base1.position)
        .to(
          {
            y: -12,
          },
          1000
        )
        .easing(TWEEN.Easing.Linear.None)
        .onComplete(() => {
          // this.scene.remove(this.base1);
        })
        .start();
      new TWEEN.Tween(this.base3.position)
        .to(
          {
            y: -12,
          },
          1000
        )
        .easing(TWEEN.Easing.Linear.None)
        .onComplete(() => {
          // this.scene.remove(this.base3);
        })
        .start();
      new TWEEN.Tween(this.base4.position)
        .to(
          {
            y: -12,
          },
          1000
        )
        .easing(TWEEN.Easing.Linear.None)
        .onComplete(() => {
          if (this.pregunta <= 3) {
            this.filtrarCuestionario();
          }
        })
        .start();
    },
    baseRobot(x, z) {
      const geometry = new Three.CylinderGeometry(3, 3, 30, 6);
      const materialcontorno = new Three.MeshLambertMaterial({
        color: 0x000000,
        wireframe: true,
      });
      const material = new Three.MeshLambertMaterial({ color: 0xffffff });
      const cylinder = new Three.Mesh(geometry, material);
      const cylinder2 = new Three.Mesh(geometry, materialcontorno);
      const geometryContorno = new Three.CylinderGeometry(2.8, 2.8, 30.2, 6);
      const materialContorno = new Three.MeshLambertMaterial({
        color: 0xff0000,
      });
      const cylinderCon = new Three.Mesh(geometryContorno, materialContorno);
      const cylinderCon2 = new Three.Mesh(geometryContorno, materialcontorno);

      const groupBase = new Three.Group();
      groupBase.add(cylinder);
      groupBase.add(cylinder2);
      groupBase.add(cylinderCon2);
      groupBase.add(cylinderCon);
      groupBase.position.x = x;
      groupBase.rotation.y = Math.PI / 2;
      groupBase.position.z = z;
      groupBase.position.y = -12;

      return groupBase;
    },
    onWindowResize() {
      this.camera.aspect = window.innerWidth / window.innerHeight;
      this.camera.updateProjectionMatrix();

      this.renderer.setSize(window.innerWidth, window.innerHeight);
    },
    filtrarCuestionario() {
      let preguntas = [];
      this.cuestionarios.forEach((element) => {
        if (element.modulo.nombre == "TRANSFORMADAS3D") {
          preguntas.push(element);
        }
      });

      this.textoPregunta = preguntas[this.pregunta - 1].pregunta;
      this.textoRespuesta1 = preguntas[this.pregunta - 1].respuestas[0];
      this.textoRespuesta2 = preguntas[this.pregunta - 1].respuestas[1];
      this.textoRespuesta3 = preguntas[this.pregunta - 1].respuestas[2];
    },
    animate: function () {
      if (
        this.$router.history.current.path == "/cuestionario-transformadas-3D"
      ) {
        window.addEventListener("resize", this.onWindowResize);

        const delta = this.clock.getDelta();

        if (this.mixer != null) {
          this.mixer.update(delta);
        }

        requestAnimationFrame(this.animate);
        TWEEN.update();
        this.renderer.render(this.scene, this.camera);
      }
    },
    logro() {
      if (this.logros.indexOf("CuestionarioTransformadas3d") != -1) {
        console.log("ya tiene este logro");
      } else {
        this.logros.push("CuestionarioTransformadas3d");
        fetch(`https://restserver-cg.onrender.com/api/usuarios/${this.decodeToken}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: `{"logros":${JSON.stringify(this.logros)},"puntaje":${
            this.puntaje
          }}`,
        })
          .then((response) => {
            console.log(response);
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    profile() {
      this.decodeToken = this.$getDataProfile(
        localStorage.getItem("token")
      ).uid;

      var axios = require("axios");

      var config = {
        method: "get",
        url: `https://restserver-cg.onrender.com/api/usuarios/${this.decodeToken}`,
        headers: {},
      };

      axios(config)
        .then((response) => {
          console.log(response.data);
          this.imageUser = response.data.img;
          this.logros = response.data.logros;
          this.puntaje = response.data.puntaje;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
  mounted() {
    this.profile();
    this.init();
    this.animate();
    var axios = require("axios");

    var config = {
      method: "get",
      url: "https://restserver-cg.onrender.com/api/cuestionarios",
      headers: {},
    };

    axios(config)
      .then((response) => {
        this.cuestionarios = response.data.cuestionarios;
        console.log(this.cuestionarios);
        this.filtrarCuestionario();
      })
      .catch(function (error) {
        console.log(error);
      });
  },
};
</script>
<style scoped>
#container {
  width: 100vw;
  height: 100vh;
}
.menu {
  position: absolute;
}
.cuestionario {
  position: absolute;
  width: 40%;
  height: fit-content;
  margin: auto;
  left: 0;
  right: 0;
  top: 30%;
  bottom: 0;
}
.pregunta {
  background: blue;
  color: white;
  padding: 1rem;
  font-weight: bold;
  font-size: 1.2rem;
  border-start-end-radius: 10px;
  border-start-start-radius: 10px;
}
.respuestas {
  font-size: 1rem;
  background: white;
  color: black;
  padding: 1rem;
  border-end-end-radius: 10px;
  border-end-start-radius: 10px;
}
.respuesta1,
.respuesta2,
.respuesta3 {
  display: none;
}
.numeroPregunta {
  position: absolute;
  font-weight: bold;
  font-size: 2rem;
  color: white;
  width: fit-content;
  left: 2rem;
  margin-top: 1rem;
}
.felicidades {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  background: white;
  border-radius: 10px;
  width: 30%;
  height: fit-content;
  /* height: 50%; */
  /* left: 0; */
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
}
.felicidades h2 {
  position: relative;
  font-weight: bold;
  font-size: 2rem;
  margin-bottom: 1rem;
  padding: 0.5rem;
  font-family: "Exo 2", sans-serif !important;
  color: black;
}
.felicidades p {
  color: black;
  /* font-weight: bold; */
  font-family: "Exo 2", sans-serif !important;
  font-size: 1rem;
  margin-bottom: 1rem;
  padding: 0 1.5rem;
}
.felicidades img {
  margin: 1rem;
  width: 35%;
}
.botonLogro {
  position: relative;

  font-size: 1.2rem;
  width: var(--espacio);
  padding: 0.8rem 1rem;
  border-radius: 6px;
  font-family: "Exo 2", sans-serif;
  background: #ffc300;
  font-weight: bold;
  cursor: pointer;
  padding: 1rem;
  margin: 1rem;
}
/* Keyboard style */
.keyboard {
  padding: 2.5em 0;
  width: 400px;
  margin: 0 auto;
  position: absolute;
  bottom: -1.5rem;
  right: 0;
  left: 0;
}
/* Top row for keyboard */
.top-row {
  width: 60px;
  /* Off Centered */
  /* width: 190px; */
  margin: 0 auto;
}
/* Bottom row for keyboard */
.bottom-row {
  display: inline-flex;
}

/* Style for each Key */
.key {
  background-color: #353943;
  /* border: 1px solid #834426; */
  border-radius: 10px;
  box-shadow: 5px 5px #c2b7ab;
  color: #ffffff;
  width: 50px;
  height: 50px;
  margin: 5px;
  text-align: center;
  top: 0;
  left: 0;
  transition: all 0.07s ease;
}
.key .arriba {
  position: absolute;
  right: 0;
  left: 0;
  margin: auto;
  top: 1rem;
  font-weight: bold;
  color: black;
}
.key .derecha {
  position: absolute;
  right: -4rem;
  /* left: 0; */
  margin: auto;
  bottom: 3.5rem;
  font-weight: bold;
  color: black;
}
.key .izquierda {
  position: absolute;
  /* right: 0; */
  left: -4rem;
  margin: auto;
  bottom: 3.5rem;
  font-weight: bold;
  color: black;
}
/* Active Class for Key */
.activeKey {
  transform: scale(1.1);
  position: relative;
  top: 0.2em;
  left: 0.2em;
  box-shadow: 0 0 0 0;
}
/* Sets font size for each Key */
.key > p {
  font-size: 2em;
}
</style>
